module.exports = __webpack_public_path__ + "img/btn-morning.c4e7e88c.png";